import { render, staticRenderFns } from "./addChapter.vue?vue&type=template&id=35c72c40&scoped=true&"
import script from "./addChapter.vue?vue&type=script&lang=js&"
export * from "./addChapter.vue?vue&type=script&lang=js&"
import style0 from "./addChapter.vue?vue&type=style&index=0&id=35c72c40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c72c40",
  null
  
)

export default component.exports